import { alphabetical, counting, sort, unique } from 'radash';

import { Component, DiagramComponentInstance } from 'models';

import { LocalStorageService } from 'services/LocalStorageService';

const LOCAL_STORAGE_KEY = 'lastUsedComponentInstances';
const LOCAL_STORAGE_LIMIT = 1000;
const PRODUCTS_LOCAL_STORAGE_KEY = 'lastUsedProducts';

type ComponentType = DiagramComponentInstance['componentType'];

const DEFAULT_MOST_USED: ComponentType[] = ['converter', 'battery', 'solar', 'panel', 'utility', 'light'];

class LastUsedComponentInstanceService {
    static add = (componentType: ComponentType) => {
        const lastUsedComponentInstances = [componentType, ...(LocalStorageService.get(LOCAL_STORAGE_KEY) || [])];

        LocalStorageService.store(LOCAL_STORAGE_KEY, lastUsedComponentInstances.slice(0, LOCAL_STORAGE_LIMIT));
    };

    static get = (): ComponentType[] => {
        return LocalStorageService.get(LOCAL_STORAGE_KEY) || [];
    };

    static getRecentlyUsed = (count: number = 3): ComponentType[] => {
        const lastUsedComponentInstances = LastUsedComponentInstanceService.get();
        const recentlyUsed = unique(lastUsedComponentInstances);

        return recentlyUsed.slice(0, count);
    };

    static getMostUsed = (count: number = 6): ComponentType[] => {
        const lastUsedComponentInstances = [...LastUsedComponentInstanceService.get(), ...DEFAULT_MOST_USED];
        const usage = counting(lastUsedComponentInstances, (componentType) => componentType);

        let mostUsed = lastUsedComponentInstances;
        mostUsed = unique(lastUsedComponentInstances);
        mostUsed = sort(mostUsed, (componentType) => usage[componentType], true);
        mostUsed = alphabetical(mostUsed, (componentType) => componentType);

        return mostUsed.slice(0, count);
    };

    static addProduct = (productId: Component['id']) => {
        const lastUsedProducts = unique([productId, ...LastUsedComponentInstanceService.getProducts()]);

        LocalStorageService.store(PRODUCTS_LOCAL_STORAGE_KEY, lastUsedProducts.slice(0, 12));
    };

    static getProducts = (): Component['id'][] => {
        return LocalStorageService.get(PRODUCTS_LOCAL_STORAGE_KEY) || [];
    };
}

export { LastUsedComponentInstanceService };
